<script type="application/ld+json">
{
  "@context": "https://schema.org",
  "@type": ["LocalBusiness", "Psychologist"],
  "@id": "https://psihoterapie-training.ro/#business",
  "name": "Cabinet Psihologie București - Psihoterapie și Dezvoltare Personală",
  "url": "https://psihoterapie-training.ro/",
  "logo": "https://psihoterapie-training.ro/assets/images/logo.png",
  "image": "https://psihoterapie-training.ro/assets/images/logo.png",
  "description": "Cabinet de psihologie din București specializat în psihoterapie cognitiv-comportamentală, consiliere psihologică și cursuri de dezvoltare personală.",
  
  "telephone": "+40745087428",
  
  "address": {
    "@type": "PostalAddress",
    "addressLocality": "București",
    "addressRegion": "București",
    "postalCode": "021172",
	"streetAddress": "Soseaua Colentina 2B",
    "addressCountry": "RO"
  },
  "founder": {
	"@type": "Person",
	"name": "Albu Raluca"
  },

  "geo": {
    "@type": "GeoCoordinates",
    "latitude": 44.4268,
    "longitude": 26.1025
  },

  "areaServed": {
    "@type": "City",
    "name": "București"
  },

  "sameAs": [
    "https://www.facebook.com/cabinetpsihologie"
  ],

  "contactPoint": {
    "@type": "ContactPoint",
    "telephone": "+40745087428",
    "contactType": "customer service",
    "areaServed": "RO",
    "availableLanguage": ["Romanian"]
  },

  "openingHoursSpecification": [
    {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday"
      ],
      "opens": "09:00",
      "closes": "19:00"
    }
  ],

  "priceRange": "$$",
  "currenciesAccepted": "RON",
  "paymentAccepted": "Cash, Credit Card",

  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Servicii Psihologice",
    "itemListElement": [
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Psihoterapie cognitiv-comportamentală București",
		      "serviceType": "Psihoterapie cognitiv-comportamentală",
          "description": "Ședințe de terapie pentru anxietate, depresie și stres."
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Consiliere psihologică",
		      "serviceType": "Consiliere psihologică",
          "description": "Sprijin emoțional și consiliere pentru diverse dificultăți personale."
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Cursuri dezvoltare personală",
		      "serviceType": "Formare și dezvoltare personală",
          "description": "Cursuri pentru gestionarea stresului și dezvoltare personală."
        }
      }
    ]
  }
}
</script>

<div class="featured">
   
    <div class="featured-text">
      <div class="featured-title">
        {{Titlul_Pagina}}
      </div>      
      <div>
        <div class="text-container">
          <div class="half">
            <img src="assets/images/raluca.jpg" alt="raluca" class="float-left">
            @for (paragraf of RalucaParagrafe; track $index) {
              <p>
                {{paragraf}}
              </p>
            }
          </div>
          <div class="half">
            <img src="assets/images/ana.jpg" alt="ana" class="float-right">
            @for (paragraf of AnaParagrafe; track $index) {
              <p>
                {{paragraf}}
              </p>
            }
          </div>
        </div>
      </div>
    </div>
    
</div>
<div id="articles" class="article">
  @for (article of Articles; track $index) {
    <div class="article-item">
      <img class="article-img" [src]="article.imageIcon || 'assets/images/cursuri.png'" [alt]="article.imageAlt || article.title">
      <h3>{{article.title}}</h3>
      <p>
        {{article.summary}}
      </p>
      <a class="article-read-more" [routerLink]="article.route">{{Citeste_Mai_Mult}}</a>
    </div>
  }
</div>
  